module.exports = "<!-- Need to pass course and exercise number here to make proper id and classes (?) -->\n<div class=\"submit\">\n  <button class=\"submit-exercise-button\" ng-bind=\"completeTitle | translate\"></button>\n  <button class=\"next-exercise-button anchor\" ng-bind=\"nextTitle | translate\"></button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/blocks/diagramComplete/diagramComplete.partial.html
// module id = 103
// module chunks = 0